export default {"src":"/_next/static/media/vk.84e10271.svg","height":14,"width":24};